import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { ITransactionTypes } from '../interface/transactionTypes';

interface ITransactionTypesRequest {
  defaultTransactionTypeId?: string;
  fields?: string[];
}

export const fetchTransactionTypeById = (id: string): Promise<ITransactionTypes> =>
  get(`${API_URLS.TRANSACTION_TYPES}/${id}`);

export const useFetchTransactionTypes = (params?: ITransactionTypesRequest) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['transaction-types', params?.defaultTransactionTypeId],
    queryFn: async () => {
      return params?.defaultTransactionTypeId
        ? fetchTransactionTypeById(params.defaultTransactionTypeId)
        : null;
    },
    enabled: !!params?.defaultTransactionTypeId,
  });
  let processedTransaction: unknown = null;
  if (!error) {
    processedTransaction = data && Object.keys(data)?.length > 0 ? data : null;
  }
  return { data: processedTransaction as ITransactionTypes, isLoading, error, refetch };
};
